import type {
  Configuration,
  PublicClientApplication,
} from '@azure/msal-browser'
import {
  AuthenticatedTemplate,
  MsalProvider as PublicMsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react'
import { Logo } from '@festina-life/ui/structure'
import type { ComponentProps, ReactElement } from 'react'

import { useMsal } from '../hooks/useMsal/useMsal'
import type { EnvironmentSettings } from '../settings/fetchAppSettings'
import type { OpenApiType } from '../utility/types'
import { SetHeaders } from './SetHeaders'
import { SignInPage } from './SignInPage'

type AuthState = ReturnType<typeof useMsal>
type Props = {
  configuration?: Configuration
  environmentSettings: EnvironmentSettings
  openApi: OpenApiType
  msalInstance: PublicClientApplication
  children: (authState: AuthState) => ReactElement
} & ComponentProps<typeof Logo>

export const MsalProvider = ({
  msalInstance,
  environmentSettings,
  openApi,
  images,
  children,
}: Props) => (
  <PublicMsalProvider instance={msalInstance}>
    <SetHeaders environmentSettings={environmentSettings} openApi={openApi}>
      <AuthenticatedTemplate>
        <InternalMsalProvider>{children}</InternalMsalProvider>
      </AuthenticatedTemplate>
    </SetHeaders>
    <UnauthenticatedTemplate>
      <SignInPage logo={<Logo images={images} />} />
    </UnauthenticatedTemplate>
  </PublicMsalProvider>
)

const InternalMsalProvider = ({
  children,
}: {
  children: (authState: AuthState) => ReactElement
}) => {
  const authState = useMsal()

  return <>{children(authState)}</>
}
